/** Brand stops (top-left → bottom-right) for Chart.js fills */
export const CHART_PRIMARY_START = '#31356e';
export const CHART_PRIMARY_END = '#1c1f4e';

/**
 * Diagonal canvas gradient across the chart plot area (matches UI primary gradient).
 * @param {CanvasRenderingContext2D} ctx
 * @param {{ left: number, top: number, right: number, bottom: number } | null} chartArea
 */
export function createPrimaryBarGradient(ctx, chartArea) {
  if (!chartArea) return CHART_PRIMARY_START;
  const g = ctx.createLinearGradient(
    chartArea.left,
    chartArea.top,
    chartArea.right,
    chartArea.bottom
  );
  g.addColorStop(0, CHART_PRIMARY_START);
  g.addColorStop(1, CHART_PRIMARY_END);
  return g;
}
